import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import IsolationGroupsResource from "@ane/exp-data/lib/resources/expapiv2/IsolationGroups.resource";
import AssignmentUnitResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentUnits.resource";
import AssignmentScopeResource from "@ane/exp-data/lib/resources/expapiunified/AssignmentScopes.resource";
import { combineEpics } from "redux-observable";
import { prefix } from "./constants.js";
const loadIsolationGroupsEpicReducerArgs = {
  actionPrefix: `${prefix}/ISOLATION_GROUPS/LOAD`,
  reduxKeyNested: () => ["isolationGroups"],
  loadResource: (inputPayload) => IsolationGroupsResource.queryIsolationGroups(inputPayload.workspaceId, {
    filter: {
      isUserManaged: true
    }
  }),
  onCompleteSuccess: (resourceResult) => resourceResult.value
};
const loadIsolationGroupsEpicReducer = loadResourcesUtils(loadIsolationGroupsEpicReducerArgs);
const loadAssignmentUnitsEpicReducerArgs = {
  actionPrefix: `${prefix}/ASSIGNMENT_UNITS/LOADV2`,
  reduxKeyNested: () => ["assignmentUnits"],
  loadResource: (inputPayload) => AssignmentUnitResource.queryAssignmentUnits(inputPayload.workspaceId),
  onCompleteSuccess: (resourceResult) => resourceResult.value
};
const loadAssignmentUnitsEpicReducer = loadResourcesUtils(loadAssignmentUnitsEpicReducerArgs);
const getLoadAssignmentUnitsEpicReducer = () => loadAssignmentUnitsEpicReducer;
const loadAssignmentScopesEpicReducerArgs = {
  actionPrefix: `${prefix}/ASSIGNMENT_SCOPES/LOAD`,
  reduxKeyNested: () => ["assignmentScopes"],
  loadResource: (inputPayload) => AssignmentScopeResource.queryAssignmentScopes(inputPayload.workspaceId),
  onCompleteSuccess: (resourceResult) => resourceResult.value
};
const loadAssignmentScopesEpicReducer = loadResourcesUtils(loadAssignmentScopesEpicReducerArgs);
const rootEpic = combineEpics(
  loadIsolationGroupsEpicReducer.epic,
  loadAssignmentUnitsEpicReducer.epic,
  loadAssignmentScopesEpicReducer.epic
);
export {
  rootEpic as default,
  getLoadAssignmentUnitsEpicReducer,
  loadAssignmentScopesEpicReducer,
  loadAssignmentUnitsEpicReducer,
  loadIsolationGroupsEpicReducer,
  rootEpic
};
//# sourceMappingURL=epics.js.map
